/* eslint-disable max-len */
import { getDomain, getLabName } from './constants';

export const getOrgDetails = async (orgId, orgEnv) => {
  // const url = orgEnv
  //   ? `https://loginapp.${getDomain()}/development/getorgdetails`
  //   : `https://loginapp.${getDomain()}/development/getorgdetails`;

  // const orgIdParam = orgEnv
  //   ? `${orgEnv}:${orgId}`
  //   : orgId;

  // let data = {};

  // try {
  //   data = await axios({
  //     url,
  //     method: 'POST',
  //     data: {
  //       orgId: orgIdParam,
  //       isOrgIdToAliasMapping: true
  //     }
  //   });
  // } catch {
  //   return Promise.reject(new Error());
  // }

  // return Promise.resolve(data);
  const data = { 'data': {} };
  try {
    // data = await axios({
    //   url: `https://loginapp.${getDomain()}/development/getorgdetails`,
    //   'Content-Type': 'application/json',
    //   method: 'POST',
    //   data: {
    //     orgId: orgId
    //   }
    // });
    data.data.envName = orgEnv;
    data.data.orgId = orgId;
    data.data.envUrl = 'https://' + getLabName(orgEnv) + 'lab' + '.' + getDomain();
    data.data.orgIdAlias = orgId;
  } catch {
    return Promise.reject(new Error());
  }
  return Promise.resolve(data);
};

export const getOrgDetailsForThreePartURL = async (orgId, envName) => {
  const data = { 'data': {} };
  try {
    // data = await axios({
    //   url: `https://loginapp.${getDomain()}/development/getorgdetails`,
    //   'Content-Type': 'application/json',
    //   method: 'POST',
    //   data: {
    //     orgId: orgId
    //   }
    // });
    data.data.envName = envName;
    data.data.orgId = orgId;
    data.data.envUrl = 'https://' + getLabName(envName) + 'lab' + '.' + getDomain();
    data.data.orgIdAlias = orgId;
  } catch {
    return Promise.reject(new Error());
  }
  return Promise.resolve(data);
};

export const getOrgDetailsForFivePartURL = async (orgId, envName ) => {
  const data = { 'data': {} };
  try {
    // data = await axios({
    //   // eslint-disable-next-line max-len
    //   url: `https://loginapp.${getDomain()}/development/getorgdetails`,
    //   'Content-Type': 'application/json',
    //   method: 'POST',
    //   data: {
    //     orgId: `${envName}:${orgId}`
    //   }
    // });
    data.data.envName = envName;
    data.data.orgId = orgId;
    data.data.envUrl = 'https://' + getLabName(envName) + 'lab' + '.' + getDomain();
    // TO FIX When backend gives org alias in some other API
    data.data.orgIdAlias = orgId;
  } catch {
    return Promise.reject(new Error());
  }
  return Promise.resolve(data);
};
